<template>
  <div>
    <LottoResultField :value="form[LottoPrizingTypeEnum.THREE_TOP]" digit="3" name="สามตัวบน" />
    <LottoResultField :value="twoTop" digit="2" disabled name="สองตัวบน" />
    <LottoResultField v-model="form[LottoPrizingTypeEnum.TWO_UNDER]" digit="2" name="สองตัวล่าง" />
  </div>
</template>

<script>

import LottoResultField from '@components/lotto/result/field';
import {LottoPrizingTypeEnum} from '@src/constants/lotto';

export default {
  name: 'LottoResultGeneral',
  components: {LottoResultField},
  props: {
    value: {
      type: Object,
      required: true
    }
  },
  data: () => ({
    form: {}
  }),
  computed: {
    LottoPrizingTypeEnum() {
      return LottoPrizingTypeEnum
    },
    twoTop() {
      const threeTop = this.form[LottoPrizingTypeEnum.THREE_TOP][0]
      return threeTop.length === 3 ? threeTop.substring(1 , 3) : ''
    }
  },
  watch: {
    form: {
      deep: true,
      handler(val) {
        this.$emit('input', val)
      }
    }
  },
  created() {
    this.form = {
      [LottoPrizingTypeEnum.THREE_TOP]: [''],
      [LottoPrizingTypeEnum.TWO_UNDER]: [''],
    }
  }
}
</script>

<style scoped>

</style>